import { createContext, useState } from 'react';
import api from 'services/api';

export const PaisContext = createContext();

export const PaisProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [pais, setPais] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getPais = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: pais?.filter,
        page: pais?.page,
        size: pais?.size,
        order: pais?.order,
        ...payload,
      });
      setPais((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <PaisContext.Provider
      value={{
        getLoading,
        pais,
        getPais,
      }}
    >
      {children}
    </PaisContext.Provider>
  );
};
